<template>
  <li class="products-overview-categories-item">
    <a
      class="products-overview-categories-item__link"
      :class="{ 'products-overview-categories-item__link--parent': category.isParentCategory }"
      :href="category.link">
      <span
        class="products-overview-categories-item__title"
        :class="{ 'products-overview-categories-item__title--active': isActive }">
        {{ category.name }}
      </span>
      <span class="products-overview-categories-item__count">
        {{ category.count }}
      </span>
    </a>
  </li>
</template>

<script>
  export default {
    name: `ProductsOverviewCategoriesItem`,
    computed: {
      isActive() {
        return window.location.href.includes(this.category.link);
      },
    },
    props: {
      category: {
        required: true,
        type: Object,
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../assets/styles/rin-variables';

  .products-overview-categories-item {
    &__count {
      color: @colorProductListDetails;
      font-size: @fontSizeS;
    }

    &__link {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 20px 20px 20px 30px;
      transition: background-color .15s ease-in-out;

      &:hover {
        background-color: @colorGreyLight;
      }
    }

    &__link--parent {
      font-family: @fontSemiBold;
      padding: 20px;
    }

    &__title {
      font-size: @fontSizeS;
      text-transform: uppercase;
    }

    &__title--active {
      border-bottom: 1px solid @colorProductListDetails;
    }
  }
</style>
